module.exports = __webpack_public_path__ + "img/@logo_orangelife@3x.f6d77a1c.png";